import { render, staticRenderFns } from "./approveUncommented.vue?vue&type=template&id=5d2cc42e&"
import script from "./approveUncommented.vue?vue&type=script&lang=js&"
export * from "./approveUncommented.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports